export default "/images/SustainabilityReport2023.gif?9d796b8e363ccb12160c768231d923a9";